import { render } from "./KnowledgeBaseView.vue?vue&type=template&id=12a23bfc&scoped=true"
import script from "./KnowledgeBaseView.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseView.vue?vue&type=script&lang=js"

import "./KnowledgeBaseView.vue?vue&type=style&index=0&id=12a23bfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a23bfc"]])

export default __exports__